import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import { clearListAllAdministrativeServicesData } from "src/redux/administrativeService/administrativeServiceActions";
import { getSelectedFundRequestType } from 'src/redux/fundRequests/fundRequestsReducer';
import { getProvisionOrderListIsFetching, getOrderPayListData } from 'src/redux/orderPay/orderPayReducer';
import { tryListOrderPay, tryOrderPayById } from 'src/redux/orderPay/orderPayActionCreator';
import { clearListOrderPayData } from 'src/redux/orderPay/orderPayActions'
import PFCommons from 'src/components/forms/fundRequest/PDForms/controls/PFCommons';
import AppLoading from 'src/components/common/AppLoading';
import PayOrderListBox from "src/components/forms/fundRequest/payOrderListBox";
import { AdministrativeServiceData } from 'src/utils/administrativeServiceUtils';

const FundRequestLoanForm = () => {

	const dispatch = useDispatch();

	//Parent Form Controller
	const { admServiceId } = useFormContext();

	//Data getter to send by props
	let dataRecords = useSelector(state => getOrderPayListData(state))?.records;
	const metaData = useSelector(state => getOrderPayListData(state))?.metadata;
	const [ordenes, setOrdenes] = useState(dataRecords);

	const selectedFundRequestType = useSelector(state => getSelectedFundRequestType(state));
	const checkToVisualize = false;
	const isFetching = useSelector(state => getProvisionOrderListIsFetching(state));

	const administrativeServiceData = AdministrativeServiceData();

	useEffect(() => {
		dispatch(clearListAllAdministrativeServicesData());
	}, [admServiceId]);

	useEffect(() => {
		if (!dataRecords?.length) {
			setOrdenes([]);
			return;
		}
		const allPromises = [];
		dataRecords.forEach(op => {
			allPromises.push(dispatch(tryOrderPayById(op.id)));
		});
		Promise.all(allPromises).then((values) => {
			setOrdenes(values);
			dataRecords = [];
		});

	}, [dataRecords]);

	return <>
		<PFCommons
			administrativeServiceData={administrativeServiceData}
			admServiceId={admServiceId}
			checkToVisualize={checkToVisualize}
		/>

		<PayOrderListBox
			selectedFundRequestType={selectedFundRequestType}
			isFetching={isFetching}
			tryMethod={tryListOrderPay}
			clearMethod={clearListOrderPayData}
			metaData={metaData}
			ordenes={ordenes}
			dataRecords={dataRecords}
		/>

		<AppLoading isLoading={isFetching} />
	</>

};

export default FundRequestLoanForm;